module.exports = __webpack_public_path__ + "static/Irriglobe_Corpo-b4e8c9bd4ca758591e4b1218570b7d41.webm";